import { Injectable } from '@angular/core';
import { Material } from 'adacad-drafting-lib';
import { createMaterial, setMaterialID } from 'adacad-drafting-lib/material';
import { BehaviorSubject } from 'rxjs';


export interface MaterialMap {
  old_id: number,
  new_id: number
}


@Injectable({
  providedIn: 'root'
})
export class MaterialsService {



  /** array ndx should be the same as shuttle id */
  materials: Array<Material> = [];
  materialColorChange: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  materialDiameterChange: BehaviorSubject<number> = new BehaviorSubject<number>(0);


  constructor() {

    //this.materials = [new Shuttle({id: 0, name: 'autogenerated', insert: true, visible: true, color: "#333333", thickness: 100, type: 0, notes: ""})];
    this.reset();

  }



  reset() {
    this.materials = [
      createMaterial({ id: 0, name: 'black', insert: true, visible: true, color: "#333333", thickness: 100, diameter: 1, type: 0, notes: "" }),
      createMaterial({ id: 1, name: 'white', insert: true, visible: true, color: "#f9f8f3", thickness: 100, diameter: 1, type: 0, notes: "" }),
      createMaterial({ id: 2, name: 'red', insert: true, visible: true, color: "#d55e00", thickness: 100, diameter: 1, type: 1, notes: "" }),
      createMaterial({ id: 3, name: 'orange', insert: true, visible: true, color: "#e69f00", thickness: 100, diameter: 1, type: 1, notes: "" }),
      createMaterial({ id: 4, name: 'yellow', insert: true, visible: true, color: "#f0e442", thickness: 100, diameter: 1, type: 1, notes: "" }),
      createMaterial({ id: 5, name: 'green', insert: true, visible: true, color: "#4aff4a", thickness: 100, diameter: 1, type: 1, notes: "" }),
      createMaterial({ id: 6, name: 'dark green', insert: true, visible: true, color: "#009e73", thickness: 100, diameter: 1, type: 1, notes: "" }),
      createMaterial({ id: 7, name: 'dark blue', insert: true, visible: true, color: "#0072b2", thickness: 100, diameter: 1, type: 1, notes: "" }),
      createMaterial({ id: 8, name: 'blue', insert: true, visible: true, color: "#56b4e9", thickness: 100, diameter: 1, type: 1, notes: "" }),
      createMaterial({ id: 9, name: 'violet', insert: true, visible: true, color: "#cc79a7", thickness: 100, diameter: 1, type: 1, notes: "" }),
      createMaterial({ id: 10, name: 'grey', insert: true, visible: true, color: "#aaaaaa", thickness: 100, diameter: 1, type: 1, notes: "" })];
  }


  getMaxDiameter(): number {
    let max_diameter = 0;
    this.materials.forEach(s => {
      let diameter = s.diameter;
      if (diameter > max_diameter) {
        max_diameter = diameter;
      }
    });

    if (max_diameter == 0) return 1;
    return max_diameter;
  }


  /**
   * overload shuttles with uploaded data. 
   * check to ensure that ids match array index and return a draft mapping
   * @param shuttles 
   */
  overloadShuttles(shuttles: Array<Material>): Array<MaterialMap> {
    console.log("OVERLOAD MATERIALS", shuttles);

    const map: Array<MaterialMap> = [];
    if (shuttles === undefined) return map;
    this.materials = [];
    return this.addShuttles(shuttles);
  }

  /**
   * adds a set of shuttles from a file import
   * @param shuttles 
   * @returns the offset of the new ids to the old ones
   */
  addShuttles(shuttles: Array<Material>): Array<MaterialMap> {

    const map: Array<MaterialMap> = [];

    const offset: number = this.materials.length;

    shuttles.forEach(s => {
      const shuttle = createMaterial(s);
      map.push({ old_id: shuttle.id, new_id: this.materials.length });
      setMaterialID(shuttle, this.materials.length);
      this.materials.push(createMaterial(shuttle));
    });

    return map;
  }

  /**
   * returns the color of the shuttle at this index
   * @param index  the id of the shuttly to get
   * @returns the color or white if null
   */
  getColor(index: number) {

    const s: Material = this.getShuttle(index);
    if (s === null) return "#ffffff";
    return (s.color);
  }

  getRGB(index: number) {
    const s: Material = this.getShuttle(index);
    return s.rgb;
  }


  getDiameter(index: number) {

    const s: Material = this.getShuttle(index);
    if (s === null) return 1;

    return s.diameter;
  }


  /**
   * adds a new material to the end of the list and updates the id.
   * @param s 
   */
  addShuttle(s: Material): number {
    s.id = this.materials.length;
    this.materials.push(s);
    return s.id;
  }


  /**
   * deletes a shuttle and readjustes the id
   * @param id 
   */
  deleteShuttle(id: number): Array<MaterialMap> {

    const new_list: Array<Material> = this.materials.filter(el => el.id != id);
    return this.overloadShuttles(new_list);

  }


  copyMaterial(material: Material): Material {
    return {
      ...material,
    };
  }


  getShuttle(id: number): Material {
    const ndx: number = this.materials.findIndex(el => el.id === id);
    if (ndx != -1) return this.copyMaterial(this.materials[ndx]);
    return null;
  }



  setMaterial(id: number, material: Material) {
    const ndx: number = this.materials.findIndex(el => el.id === id);
    if (ndx != -1) {
      let flagColor = false;
      let flagDiameter = false;
      if (this.materials[ndx].color != material.color) flagColor = true;
      if (this.materials[ndx].diameter != material.diameter) flagDiameter = true;
      this.materials[ndx].name = material.name;
      this.materials[ndx].color = material.color;
      this.materials[ndx].diameter = material.diameter;
      this.materials[ndx].notes = material.notes;
      this.materials[ndx].rgb = material.rgb;

      if (flagColor) this.materialColorChange.next(id);
      if (flagDiameter) this.materialDiameterChange.next(id);

    }

  }


  getNextShuttle(id: number): Material {
    let ndx: number = 0;
    if (id === undefined || id === null) ndx = this.getFirstShuttle().id;
    else ndx = this.materials.findIndex(el => el.id === id)

    if (ndx === -1) {
      console.error("material with id", id, "not found");
      return this.getFirstShuttle();
    } else {
      return this.materials[(ndx + 1) % this.materials.length];
    }

  }

  getShuttles(): Array<Material> {
    return this.materials;
  }

  exportForSaving(): Array<Material> {
    return this.materials;
  }

  getFirstShuttle(): Material {
    if (this.materials.length === 0) {
      console.error("no materials loaded");
      return null;
    }
    return this.materials[0];
  }

  getShuttleByRGB(r: number, g: number, b: number): number {

    this.materials.forEach(el => {
      if (el.rgb.r === r && el.rgb.g === g && el.rgb.b === b) {
        return el.id;
      }
    });
    return -1;

  }

  /**
   * given a list of material mappings, returns a list where they are all teh same size, 
   * @param systems the system mappings to compare
   */
  standardizeLists(shuttles: Array<Array<number>>): Array<Array<number>> {

    if (shuttles.length === 0) return [];

    const standard = shuttles.map(el => el.slice());

    //standardize teh lengths of all the returned arrays 
    const max_length: number = standard.reduce((acc, el) => {
      const len = el.length;
      if (len > acc) return len;
      else return acc;
    }, 0);


    standard.forEach((sys, ndx) => {
      if (sys.length < max_length) {
        for (let i = sys.length; i < max_length; i++) {
          sys.push(sys[0]);
        }
      }
    });

    return standard;
  }

}
